import { RECTANGULAR_SIZES, SQUARE_SIZES } from '../constants';
import { ImageSizes, ImageSizeTypes } from '../types';

export function getImageSize(sizeType, size) {
  if (sizeType === ImageSizeTypes.RECTANGLE) {
    return RECTANGULAR_SIZES[size || ImageSizes.MEDIUM];
  }
  return SQUARE_SIZES[size || ImageSizes.MEDIUM];
}

export function getImageSizeType(sizeType, size) {
  if (sizeType === ImageSizeTypes.RECTANGLE) {
    return Object.keys(RECTANGULAR_SIZES).find((key) => RECTANGULAR_SIZES[key] === size);
  }
  return Object.keys(SQUARE_SIZES).find((key) => SQUARE_SIZES[key] === size);
}